import { render } from "./email-verification.vue?vue&type=template&id=14ce1d84"
import script from "./email-verification.vue?vue&type=script&lang=js"
export * from "./email-verification.vue?vue&type=script&lang=js"

import exportComponent from "/home/krupali/vuejs/borex-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__